import { useSearchParams } from 'react-router-dom';
import { Alert } from '@/components/ui/primitives';
import { safeReturnTo } from '../opd/BookAppointmentPage';
import { insuranceTabPath } from './insurance-routes';
import { ManualPreAuthPage } from './ManualPreAuthPage';
import { PharmacyPreAuthPage, type PharmacyPreAuthTarget } from './PharmacyPreAuthPage';
import { PreAuthRequestPage } from './PreAuthRequestPage';

function pharmacyTarget(params: URLSearchParams): PharmacyPreAuthTarget | null {
  const storeId = params.get('storeId') ?? undefined;
  const patientId = params.get('patientId');
  const prescriptionId = params.get('prescriptionId');
  if (params.get('mode') === 'prescription' && patientId && prescriptionId) return { mode: 'prescription', patientId, prescriptionId, storeId };
  if (params.get('mode') === 'walk-in' && storeId) return { mode: 'walk-in', storeId };
  return null;
}

export function PreAuthNewPage() {
  const [params] = useSearchParams();
  const kind = params.get('kind') ?? 'request';
  const returnTo = safeReturnTo(params.get('returnTo'), insuranceTabPath('preauth'));

  if (kind === 'manual') return <ManualPreAuthPage returnTo={returnTo} />;
  if (kind === 'pharmacy') {
    const target = pharmacyTarget(params);
    if (!target) return <Alert variant="destructive">This request needs a store or a prescription to start from.</Alert>;
    return <PharmacyPreAuthPage key={`${target.mode}-${target.prescriptionId ?? target.storeId}`} target={target} returnTo={returnTo} />;
  }
  return (
    <PreAuthRequestPage
      returnTo={returnTo}
      initial={{
        patientId: params.get('patientId') ?? undefined,
        payerId: params.get('payerId') ?? undefined,
        admissionId: params.get('admissionId') ?? undefined,
      }}
    />
  );
}
